const CashInMethod = {
  Card: "card",
  OverTheCounter: "otc",
  OnlineBanking: "online-banking",
  ManualBankDeposit: "manual-bank-deposit",
  VIPBizPoints: "vip-biz-points",
};

export default CashInMethod;
